function emitWarning() {
    if (!emitWarning.warned) {
      emitWarning.warned = true;
      console.log(
        'Deprecation (warning): Using file extension in specifier is deprecated, use "highlight.js/lib/languages/ocaml" instead of "highlight.js/lib/languages/ocaml.js"'
      );
    }
  }
  emitWarning();
    module.exports = require('./ocaml.js');